export class GarfieldFundNode {
	id: string;

	constructor(
		public fundCategoryId: number | typeof ALL_FUNDS,
		public fundTypeId: number | null,
		public fund: string | null,
	) {
		this.id = this.generateId();
	}

	// generate comma-delimited list from fundCategory, fundTypeId, and fund
	// don't include fundTypeId or fund is null
	// e.g. fund type = Enterprise, 2,2
	private generateId = () => {
		const id: (number | typeof ALL_FUNDS | string)[] = [this.fundCategoryId];

		if (this.fundTypeId || this.fundTypeId === 0) {
			id.push(this.fundTypeId);
		}
		if (this.fund) {
			id.push(this.fund);
		}
		return id.join();
	}

	public fieldName = (): string => {
		return (this.fund === null || this.fund === undefined) ?
			(this.fundTypeId === null || this.fundTypeId === undefined) ?
				this.fundCategoryId === ALL_FUNDS ?
					'allFunds' :
					'fundCategoryId' :
				'fundTypeId' :
			'fund';
	};

	toString = () => this.id;
}

export class GarfieldFundNodeVM extends GarfieldFundNode {
	constructor(
		fundCategoryId: number | typeof ALL_FUNDS,
		fundTypeId: number | null,
		fund: string | null,
		public selected: boolean,
		public isVisible: boolean,
		public disabled: boolean,
		public label: string,
		public focus: boolean,
		public isExpandable: boolean,
		public expanded: boolean,
		public depth: number
	) {
		super(fundCategoryId, fundTypeId, fund)
	}
}

export const ALL_FUNDS = 'All funds';
